// extracted by mini-css-extract-plugin
module.exports = {"tickerDiv":"styles_tickerDiv__BnbjO","phrase":"styles_phrase__jPU_E","tickerBanner":"styles_tickerBanner__QZQjV","tickerBadge":"styles_tickerBadge__rzADv"};